export interface ListenOptions {
  /** Close the mic if nobody starts talking within this time (SPEC 6.1: ~8 s after a question). */
  timeoutMs: number;
  /** Hard cap for one utterance. */
  maxMs?: number;
  onPartial?: (text: string) => void;
  /** Recognizer problem worth showing (missing permission, no service); silence is not reported. */
  onError?: (message: string) => void;
}

/** Speech to text. Audio never leaves the device as a recording; only the transcript is kept. */
export interface VoiceInput {
  readonly kind: string;
  available(): Promise<boolean>;
  /** Resolves with the transcript, or null on silence, timeout or error. */
  listen(opts: ListenOptions): Promise<string | null>;
  stop(): void;
  /** Human-readable microphone / recognizer state for Settings. */
  diagnose?(): Promise<string>;
}

/** Text to speech. Interface allows a paid TTS later. */
export interface VoiceOutput {
  readonly kind: string;
  speak(text: string): Promise<void>;
  stop(): void;
  voices(): Promise<string[]>;
  setVoice(name: string): void;
}

export const silentOutput: VoiceOutput = {
  kind: "silent",
  speak: async () => {},
  stop: () => {},
  voices: async () => [],
  setVoice: () => {},
};

export const noInput: VoiceInput = {
  kind: "none",
  available: async () => false,
  listen: async () => null,
  stop: () => {},
};
